import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import PublicationsPageContent from "../components/publications/publications-page";

const PublicationsPage = () => {
  return (
    <Layout>
      <PublicationsPageContent />
    </Layout>
  );
};

export default PublicationsPage;

export const Head = () => <Seo title="Publications" />;